import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

import formatCurrency from 'components/utils/formatCurrency';
import billingTypes from 'data/billing_types';

const pricyByCurrency = (abbr) => {
  if (abbr === 'GBP' || abbr === 'CHF') {
    return 100;
  } if (abbr === 'USD') {
    return 100;
  }
  return 135;
};

export default function ShortSummary({ plan }) {
  const annualDiscountPresent = plan.attributes.payment_mode === 'annual' && plan.attributes.annual_discount !== '';
  const discountsPresent = plan.attributes.monthly_discount_enable || annualDiscountPresent;

  const abbr = plan.attributes.currency.title;
  const { mark } = plan.attributes.currency;

  return (
    <>
      <div className="fs-4">{plan.attributes.name}</div>

      <div className="mt-2">
        <small>Coaching Sessions Per Employee:</small>

        <div>
          {plan.attributes.sessions === 0 ? 'Assessment Only' : plan.attributes.sessions}
        </div>
      </div>
      {plan.attributes.payment_information_id !== null && (
      <div className="mt-2">
        <small>Payment Method:</small>

        <div>
          {plan.attributes.payment_information_label}
        </div>
      </div>
      )}

      <Row className="mt-2">
        <Col>
          <small>Effective date:</small>

          <div>{plan.attributes.effective_date_form}</div>
        </Col>

        <Col>
          <small>Renewal date:</small>

          <div>{plan.attributes.renewal_date_form}</div>
        </Col>
      </Row>

      <Row className="mt-2">
        <Col>
          <small>Billing type:</small>

          <div>{billingTypes.find((item) => item.value === plan.attributes.payment_mode).label }</div>
        </Col>

        <Col>
          <small>Members:</small>

          <div>{plan.attributes.employees_covered}</div>
        </Col>
      </Row>

      {plan.attributes.monthly_custom_records.length > 0 && (
        <div className="mt-2">
          <div>Additional Services:</div>

          {plan.attributes.monthly_custom_records.map((item) => (
            <div key={item.id} className="d-flex justify-content-between">
              <small>{item.name}</small>
              <small>
                <span className="me-1 fs-5">
                  {mark}
                  {formatCurrency(item.price, '')}
                </span>
                <span className="fw-light">{abbr}</span>
              </small>
            </div>
          ))}
        </div>
      )}

      <hr />

      {discountsPresent && (
        <div className="mt-2">
          <div>Discounts:</div>

          {plan.attributes.monthly_discount_enable && (
            <div className="d-flex justify-content-between">
              <small>{plan.attributes.monthly_discount_name}</small>
              <small className="ms-1">
                -
                {' '}
                {plan.attributes.monthly_discount}
                %
              </small>
            </div>
          )}

          {annualDiscountPresent && (
            <div className="d-flex justify-content-between mt-1">
              <small>Annual Discount</small>
              <small className="ms-1">
                -
                {' '}
                {plan.attributes.annual_discount}
                %
              </small>
            </div>
          )}
        </div>
      )}

      <div className="d-flex justify-content-between mt-2">
        <div>PEPM:</div>

        <div className="ms-1">
          {formatCurrency(plan.attributes.price_employee_month, abbr)}
        </div>
      </div>

      <small key="pepm-notice">
        Minimum
        {' '}
        {mark}
        {pricyByCurrency(plan.attributes.currency.title)}
        /month
      </small>

      <div className="d-flex justify-content-between mt-2 fs-5">
        <div>PREMIUM:</div>

        <div className="ms-1">
          {formatCurrency(plan.attributes.monthly_total, abbr)}
        </div>
      </div>

      {plan.attributes.onetime_custom_records.length > 0 && (
        <>
          <div className="mt-2">One-Time Premium</div>

          {plan && plan.attributes.onetime_custom_records.map((item) => (
            <div key={item.id} className="d-flex justify-content-between mt-1">
              <small>{item.name}</small>
              <small>
                <span className="me-1 fs-5">
                  {mark}
                  {formatCurrency(
                    parseFloat(item.price) * (
                      item.is_activation_fee && plan.attributes.activation_fee_type === 'member'
                        ? parseFloat(plan.attributes.employees_covered)
                        : 1
                    ),
                    '',
                  )}
                </span>
                <span className="fw-light">{abbr}</span>
              </small>
            </div>
          ))}

          {plan.attributes.onetime_discount !== '' && (
            <div>
              <small>{plan.attributes.onetime_discount_name}</small>
              <small className="ms-1">
                {plan.attributes.onetime_discount}
                %
              </small>
            </div>
          )}
        </>
      )}
    </>
  );
}

ShortSummary.propTypes = {
  plan: PropTypes.object.isRequired,
};
